import { render } from "./mobMenu.vue?vue&type=template&id=b4a53d56&scoped=true"
import script from "./mobMenu.vue?vue&type=script&lang=js"
export * from "./mobMenu.vue?vue&type=script&lang=js"

import "./mobMenu.vue?vue&type=style&index=0&id=b4a53d56&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a53d56"]])

export default __exports__